var _circle, _circle2, _path, _path2, _path3, _path4, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCatFunny(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 38,
    fill: "#fffbe6",
    stroke: "#f5e080",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 20,
    fill: "#f9d64f",
    stroke: "#c8a800",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 34 Q33 30 36 34",
    stroke: "#4a3800",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 34 Q47 30 50 34",
    stroke: "#4a3800",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 43 Q40 58 52 43",
    fill: "#4a3800"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 45 Q40 56 50 45 L50 49 Q40 58 30 49Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40,
    cy: 52,
    rx: 6,
    ry: 4,
    fill: "#e84040",
    opacity: 0.9
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26,
    cy: 44,
    rx: 5,
    ry: 3,
    fill: "#f7a8a8",
    opacity: 0.6
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54,
    cy: 44,
    rx: 5,
    ry: 3,
    fill: "#f7a8a8",
    opacity: 0.6
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26,
    cy: 36,
    rx: 2,
    ry: 3,
    fill: "#a0d0ff",
    opacity: 0.8
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54,
    cy: 36,
    rx: 2,
    ry: 3,
    fill: "#a0d0ff",
    opacity: 0.8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatFunny);
export default __webpack_public_path__ + "static/media/cat-funny.e8607bb7c22d7cc43939ded4d7091d97.svg";
export { ForwardRef as ReactComponent };